import { ReactNode, useLayoutEffect, useMemo } from 'react';
import { LibraryContext } from 'app/shared/u21-ui/components/contexts';
import { setThemeMode } from 'app/shared/u21-ui/components/utils';
import { U21Themes } from 'vendor/material-minimal/models';
import { U21Theme } from 'vendor/material-minimal';
import { LicenseInfo } from '@mui/x-license';

import '@fontsource/dm-sans/index.css';
import '@fontsource/lato/index.css';
import 'katex/dist/katex.min.css';

interface Props {
  children: ReactNode;
  direction?: 'ltr' | 'rtl';
  disableExternalLinkModal?: boolean;
  license?: string;
  mode?: U21Themes;
  reportError?: typeof console.error;
}

export const U21ComponentLibrary = (props: Props) => {
  const {
    children,
    direction = 'ltr',
    disableExternalLinkModal = false,
    license,
    // eslint-disable-next-line no-console
    reportError = console.error,
    mode = U21Themes.LIGHT,
  } = props;

  useLayoutEffect(() => {
    if (license) {
      LicenseInfo.setLicenseKey(license);
    }
  }, [license]);

  useLayoutEffect(() => {
    setThemeMode(mode);
  }, [mode]);

  const contextValue = useMemo(
    () => ({ disableExternalLinkModal, reportError }),
    [disableExternalLinkModal, reportError],
  );

  return (
    <LibraryContext.Provider value={contextValue}>
      <U21Theme direction={direction} mode={mode}>
        {children}
      </U21Theme>
    </LibraryContext.Provider>
  );
};
